export default __webpack_public_path__ + "resources/icons/map-pin.svg";